// ==========================================================================
// The main file for the Searchbar
// ==========================================================================

import { removeElement } from './helpers';
import './filter-and-search';
import DropdownGuests from './dropdown-guests';
import URLSearchParams from 'url-search-params';
import DesktopSearchBarLocationModal from './modals/DesktopSearchBarLocationModal';
import DateRangeSelector from './search/DateRangeSelector';
import SearchModel from './search/SearchModel';
import SearchSubmitButton from './search/SearchSubmitButton';
import parse from 'date-fns/parse';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

class Searchbar {
  constructor() {
    window.URLSearchParams = URLSearchParams;
    this.searchForm = document.querySelector('.search-form');
    this.elements = {
      camp_modal_opener: document.querySelector('#main_menu_camp_modal_trigger'),
    };
  }

  init() {
    if (!this.searchForm) return;

    this.searchForm.addEventListener('submit', event => {
      event.preventDefault();
    });

    this.field = {
      camp: this.searchForm.querySelector('#id_camp'),
      accommodation: this.searchForm.querySelector('#id_accommodation_type'),
      promoCodeContainer: this.searchForm.querySelector(
        '#id_promo_code_container',
      ),
      promoCodeError: this.searchForm.querySelector('.sfi-promo-error'),
      promoCode: this.searchForm.querySelector('#id_promo_code'),
      children: this.searchForm.querySelector('.js-dgi-input-children'),
      adults: this.searchForm.querySelector('#id_adults'),
      pets: this.searchForm.querySelector('#id_guests_pets'),
      searchBtn: this.searchForm.querySelector('#searchBtn'),
      clearPromoCode: this.searchForm.querySelector('#id_clear_promo_code'),
      // destination: document.querySelector('#id_destination')
    };

    /* global CampingAdriaticGlobals */
    const languageCode = document.querySelector('html').getAttribute('lang');
    const seasonRanges = CampingAdriaticGlobals.season_ranges.map(range => {
      return {
        startDate: (range.startDate === null) ? null : parse(range.startDate, 'yyyy-MM-dd', new Date(), { awareOfUnicodeTokens: true}),
        endDate: (range.endDate === null) ? null : parse(range.endDate, 'yyyy-MM-dd', new Date(), { awareOfUnicodeTokens: true }),
      };
    });

    const searchInitState = {
      ...CampingAdriaticGlobals.init_search_parameters,
      'arrival': parse(CampingAdriaticGlobals.init_search_parameters.arrival, 'yyyy-MM-dd', new Date(), { awareOfUnicodeTokens: true}),
      'departure': parse(CampingAdriaticGlobals.init_search_parameters.departure, 'yyyy-MM-dd', new Date(), { awareOfUnicodeTokens: true}),
    };
    /* global CampingAdriaticGlobals */

    this.searchModel = new SearchModel(searchInitState, seasonRanges, CampingAdriaticGlobals.change_search_url);
    this.searchModel.searchData$.subscribe((search) => {
      //console.log(JSON.stringify(search));
    });
    this.datapicker = new DateRangeSelector(
      {
        start_container: document.querySelector('.datepicker-start'),
        start_field: document.querySelector('#StartUserField'),
        end_container: document.querySelector('.datepicker-end'),
        end_field: document.querySelector('#EndUserField'),
      }, languageCode, this.searchModel, seasonRanges);

    this.searchButton = new SearchSubmitButton(document.getElementById('searchBtn'), this.searchModel);

    this.dropdownGuestInput = new DropdownGuests(
      {
        select: document.querySelectorAll('.js-dgi-select'),
        select_children: document.querySelector('.js-dgi-select-children'),
        input_children: this.field.children,
        preview_value: document.querySelector('.js-dgi-preview-value'),
        dropdown: document.querySelector('.js-dgi-dropdown'),
        children: document.querySelector('.js-dgi-children'),
        template: document.querySelector('.js-dgi-template'),
        open_btn: document.querySelectorAll('.js-gdi-open'),
        close_btn: document.querySelectorAll('.js-dgi-close'),
        adults_selector: document.getElementById('id_adults'),
      },
      false,
      () => {
        // Callback...
      }, this.searchModel
    );

    this.updateUrl = this.searchForm.getAttribute('data-url');
    this.submitUrl = this.searchForm.getAttribute('action');
    this.bindEvents.bind(this);
    this.bindEvents();
  }

  bindEvents() {
    if (!CampingAdriaticGlobals['booking_update_reservation']) {
      this.elements.camp_modal_opener.addEventListener('click', eventObj => {
        eventObj.preventDefault();
        eventObj.stopPropagation();
        const campSelectorModal = new DesktopSearchBarLocationModal(this);
        campSelectorModal.open();
      });
    }

    // Camp type
    // --------------------------------------------------------------------------
    this.field.camp.addEventListener('change', () => {
      this.searchModel.setCampCodes(this.field.camp.value);
    });

    // Accommodation type
    // --------------------------------------------------------------------------
    this.field.accommodation.addEventListener('change', () => {
      this.searchModel.setAccommodationType(this.field.accommodation.value);
    });

    // Adults
    // --------------------------------------------------------------------------
    this.field.adults.addEventListener('change', () => {
      this.searchModel.setNumOfAdults(this.field.adults.value);
    });

    // Pets
    // --------------------------------------------------------------------------
    this.field.pets.addEventListener('change', () => {
      this.searchModel.setNumOfPets(this.field.pets.value);
    });

    // Children
    // --------------------------------------------------------------------------
    /*
    TODO: check if this is relevant
    this.field.children.addEventListener('input', () => {
      this.callUpdateUrlSimple(this.field.children, 'children');
    });
    */

    fromEvent(this.field.promoCode, 'input').pipe(debounceTime(200)).subscribe(() => {
      this.searchModel.setPromoCode(this.field.promoCode.value);
    });


    // Clear promo code
    // --------------------------------------------------------------------------
    this.field.clearPromoCode.addEventListener('click', () => {
      const input = document.getElementById('clearPromoData');
      this.field.promoCode.value = '';
      input.value = '';
      document.body.setAttribute('style', 'cursor: wait !important;');
      this.searchModel.clearPromoCode();
    });

    this.searchModel.searchError$.subscribe(errorData => {
      if (errorData.error && errorData.field === 'promo_code') {
        this.field.promoCodeContainer.classList.add('has-error');
        this.field.promoCodeContainer.classList.remove('promo-valid');
        this.field.promoCodeError.textContent = errorData.message;
      }
      if (!errorData.error) {
        this.field.promoCodeContainer.classList.remove('has-error');
        this.field.promoCodeError.textContent = '';
      }
    });

    this.searchModel.searchResponse$.subscribe(responseData => {
      if (responseData.promo_code_cleared !== undefined && responseData.promo_code_cleared) {
        const params = new URLSearchParams(location.search);
        params.delete('promo_code');
        params.delete('price_list');
        window.history.replaceState({}, '', `${location.pathname}?${params}`);
        window.location.reload();
      }
      if (responseData.url) {
        this.field.searchBtn.setAttribute('href', responseData.url);
      }
      if (responseData.gtm_label) {
        this.field.searchBtn.setAttribute('data-gtm-label', responseData.gtm_label);
      }
      if (responseData.acc_types) {
        [...this.field.accommodation.options].map(option => {
          removeElement(option);
        });
        for (let key in responseData.acc_types) {
          const opt = new Option(responseData.acc_types[key].title, key);
          if (responseData.acc_types[key].selected) opt.selected = true;
          this.field.accommodation.add(opt);
        }
      }
    });
  }
}

export default Searchbar;



// WEBPACK FOOTER //
// ./src/js/searchbar.js